// Module
var code = "<tour-step-body><span translate=\"same-name-tour-body\"></span></tour-step-body>";
// Exports
module.exports = code;